module.exports = __webpack_public_path__ + "img/20191114165844795.294e5235.jpg";